export const Fonts = {
  Montserrat: {
    Light: 'Montserrat-Light',
    Regular: 'Montserrat-Regular',
    Medium: 'Montserrat-Medium',
    SemiBold: 'Montserrat-SemiBold',
    Bold: 'Montserrat-Bold',
  }
} as const;

export const FontWeights = {
  light: '300',
  regular: '400',
  medium: '500',
  semiBold: '600',
  bold: '700',
} as const;
